// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f1aec7f0","703":"ccdf1c26","820":"b2bf54bd"}[chunkId] + ".chunk.js";
};